import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ProfilePage from './Profile/ProfilePage';
import DesktopSuperAdminLayout from 'shared/components/layout/DesktopSuperAdminLayout';
import OrganizationsPage from './Organizations/OrganizationsPage';
import Reports from './Reports/Reports';
import OrganizationForm from './Organizations/OrganizationForm';
import UsersPage from './Users/UsersPage';
import UserForm from './Users/UserForm';
import { AuthConsumer } from 'shared/contexts/AuthContext';
import StudentCourseContentReport from './Reports/StudentCourseContentReport';

type Props = {}

const LayoutSuperAdmin: React.FunctionComponent<Props> = () => {
    const AppLayout = DesktopSuperAdminLayout;
    return (
        <AuthConsumer>
            {({ isAuth }) =>
                !isAuth ? (
                    <Route exact>
                      <Redirect to={'/login'}/>
                    </Route>
                ) : (
                <AppLayout>
                    <Switch>
                        <Route exact path="/my/profile" component={ProfilePage}/>
                        <Route exact path="/organizations" component={OrganizationsPage}/>
                        <Route exact path="/admins" component={UsersPage}/>
                        <Route exact path="/organizations/:mode" component={OrganizationForm}/>
                        <Route exact path="/organizations/:id/:mode" component={OrganizationForm}/>
                        <Route exact path="/admins/:mode" component={UserForm}/>
                        <Route exact path="/admins/:id/:mode" component={UserForm}/>

                        <Route exact path="/reports/:type" component={Reports}/>
                        
                        <Route exact path="/reports/:type/:id" component={Reports}/>
                        <Route exact path="/reports/users/:userId/course/:courseId" component={StudentCourseContentReport}/>
                        <Route exact>
                            <Redirect to={'/organizations'}/>
                        </Route>
                    </Switch>
                </AppLayout>
                )
            }
        </AuthConsumer>
    );
};

export default LayoutSuperAdmin;
